<template>
    <main>
        <deskSession/>   
    </main>
</template>

<script>
import { LMap, LTileLayer, LMarker,LPopup,LCircle,LCircleMarker } from 'vue2-leaflet'
// Import the EventBus we just created.
import { EventBus } from '../../../helpers/eventbus/event-bus.js'

import initVue from '../../../helpers/initVue'
import deskSession from './deskSession'

import {
    mapGetters,
    mapActions
} from 'vuex'

export default {
    data(){
        return {
            n: 7,
            identity: null,
            token: null,
            session: false,
            userstorage: null,
            verificate_status_email: false
        }
    },

    computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
    }),

    components:{
        deskSession,
    },

    async mounted(){
        this.getidentity()
        await this.getuser()

        await EventBus.$on('getuser', () =>{
            this.getuser()
        })
        //this.verificate_status_email = this.userstorage.verificate_status_email
    },

    methods: {
        getuser(){
            if(this.session){
                this.axios.get(`users/getuser`)
                .then((res) => {

                    this.userstorage = res.data.user
                    
                })
                .catch((err) => {
                    console.log(err)
                })
            }
        },
        /*******************************************************
 * * Obteniendo la identidad para validar el token
 *******************************************************/
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            //console.log(this.session)
    
        },

        opencompanyregister(){
            EventBus.$emit('companyregister')
        }
    }
}
</script>